/* eslint-disable */

import { SHA3 } from 'sha3'

export function getSha3Hash(s) {
  const hash = new SHA3(512)
  hash.update(s)
  return hash.digest('hex')
}

export function consoleLogHeader(s) {
  console.log(`\n\n===== ${s} ====================\n`)
}

export function consoleLogHeaderItem(s) {
  console.log(`-- ${s}\n`)
}

export function titleCase(string) {
  const sentence = string.toLowerCase().split(' ')
  for (let i = 0; i < sentence.length; i++) {
    sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1)
  }
  return sentence.join().replace('_', ' ')
}

export function formatDate(d) {
  const ret = new Date(d)
  if (ret < new Date('1/1/2000')) {
    return '--'
  } else {
    return ret.toLocaleDateString()
  }
}

export function getRandomUuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  )
}

// helper function since optional chaining might not be possible in this module
export function chain(obj, arrayValues) {
  if (!obj) {
    return undefined
  }

  if (arrayValues && arrayValues.length === 0) {
    return obj
  }

  for (let i = 0; i < arrayValues.length; i++) {
    const element = arrayValues[i]
    if (obj[element]) {
      arrayValues.shift()
      return chain(obj[element], arrayValues)
    } else {
      return undefined
    }
  }
}
